import { inherits as _inherits, createClass as _createClass, typeof as _typeof, extends as _extends, asyncToGenerator as _asyncToGenerator, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import deepmerge from 'deepmerge';
import { FormSaveButtons } from './FormSaveButtons.js';
import { FieldGroup } from './FieldGroup.js';
import Form$1 from 'react-bootstrap/Form';
import { ConfirmationModal } from '../ConfirmationModal/index.js';
import { CancelConfirmModal } from '../CancelConfirmModal/index.js';
import { AlertMessageTypes } from '../../constants/index.js';
import { i18n } from '../../i18n/translate.js';
import { JsonApiRecordDecorator } from '../../json-api/JsonApiRecordDecorator.js';
import _get from 'lodash/get';
import { AlertMessage } from '../AlertMessage/component.js';

var Form = /*#__PURE__*/function (_React$Component) {
  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _callSuper(this, Form, [props]);

    _defineProperty(_this, "toggleDeleteModal", function () {
      _this.setState({
        deleteModal: !_this.state.deleteModal
      });
    });

    _defineProperty(_this, "onValueChange", function (obj) {
      Object.assign(_this.props.data, obj);
    });

    _defineProperty(_this, "save", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(addAnother) {
        var form, currentData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form = _this.bootstrapForm;

                if (!form.checkValidity()) {
                  _context.next = 16;
                  break;
                }

                currentData = _this.serializeForm(form);

                if (!currentData.id) {
                  _context.next = 9;
                  break;
                }

                if (!_this.props.updateAction) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return _this.props.updateAction(currentData);

              case 7:
                _context.next = 12;
                break;

              case 9:
                if (!_this.props.addAction) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return _this.props.addAction(currentData, addAnother);

              case 12:
                _this.setState({
                  isDisabled: false
                });

                return _context.abrupt("return", currentData);

              case 16:
                _this.setState({
                  errorMessage: i18n.t('Errors on the form!'),
                  runValidation: true,
                  isDisabled: false
                });

                if (typeof _this.props.onInvalidFormSubmit === 'function') {
                  _this.props.onInvalidFormSubmit();
                }

                return _context.abrupt("return", false);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_this, "saveAndAdd", function (e) {
      e.preventDefault();

      _this.setState({
        isDisabled: true
      });

      _this.save(true);
    });

    _defineProperty(_this, "saveAndClose", function (e) {
      e.preventDefault();

      _this.setState({
        isDisabled: true
      });

      _this.save();
    });

    _defineProperty(_this, "onCancel", function () {
      var form = _this.bootstrapForm;

      var currentData = _this.serializeForm(form);

      if (currentData.isDirty && !_this.props.skipCancelConfirmation) {
        _this.setState({
          showCancelConfirm: true
        });

        return;
      }

      if (_this.props.onCancel) {
        _this.props.onCancel();
      }
    });

    _defineProperty(_this, "serializeForm", function (form) {
      var obj = serialize(form, {
        hash: true,
        empty: true
      }); // form-serialize does not serialize checkbox array correctly if only last item is checked

      _this.normalizeStructures(obj);

      var newData = new JsonApiRecordDecorator();

      if (_this.props.deepMerge) {
        var merged = deepmerge.all([newData, _this.props.data, obj]);
        newData = Object.assign(newData, _this.props.data, merged);
      } else {
        newData = Object.assign(newData, _this.props.data, obj);
      }

      return newData;
    });

    _defineProperty(_this, "onCancelClose", function (close) {
      _this.setState({
        showCancelConfirm: false
      });

      if (close && _this.props.onCancel) {
        _this.props.onCancel();

        return;
      }

      if (_this.props.onCancelClose) {
        _this.props.onCancelClose();
      }
    });

    _defineProperty(_this, "deleteRecord", function () {
      if (_this.props.deleteDisableButtons) {
        _this.setState({
          isDisabled: true
        });
      }

      _this.props.deleteAction(_this.props.data);

      _this.toggleDeleteModal();
    });

    _defineProperty(_this, "clearMessages", function () {
      var clearMessages = _this.props.clearMessages;

      _this.setState({
        errorMessage: null
      });

      if (clearMessages) {
        clearMessages();
      }
    });

    _this.state = {
      errorMessage: props.errorMessage,
      isDisabled: props.disableButtons,
      deleteModal: false
    };
    return _this;
  }

  _inherits(Form, _React$Component);

  return _createClass(Form, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(prevProps) {
        var addAnother, formValidated;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.props.disableButtons && prevProps.disableButtons || this.props.successMessage && !prevProps.successMessage) {
                  this.setState({
                    isDisabled: false
                  });
                }

                if (this.props.errorMessage && this.props.errorMessage !== prevProps.errorMessage) {
                  this.setState({
                    errorMessage: this.props.errorMessage,
                    runValidation: true,
                    isDisabled: false
                  });
                }

                if (!(this.props.triggerSave && !prevProps.triggerSave || this.props.triggerSaveAndAdd && !prevProps.triggerSaveAndAdd)) {
                  _context2.next = 15;
                  break;
                }

                _context2.prev = 3;
                addAnother = this.props.triggerSaveAndAdd;
                _context2.next = 7;
                return this.save(addAnother);

              case 7:
                formValidated = _context2.sent;

                if (this.props.saveComplete) {
                  this.props.saveComplete(!!formValidated);
                }

                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);
                this.setState({
                  errorMessage: _context2.t0.message,
                  runValidation: true,
                  isDisabled: false
                });

                if (this.props.saveComplete) {
                  this.props.saveComplete(false);
                }

              case 15:
                if (this.props.triggerCancel && !prevProps.triggerCancel && this.onCancel) {
                  this.onCancel();
                }

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 11]]);
      }));

      function componentDidUpdate(_x2) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "normalizeStructures",
    value: function normalizeStructures(source) {
      var _this2 = this;

      var stack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var data = this.props.data;

      function getDataValue(key) {
        if (stack.length) {
          return _get(data, stack.concat(key));
        }

        return data[key];
      }

      Object.keys(source).forEach(function (key) {
        var wasArrayValue = Array.isArray(getDataValue(key));
        var currentValue = source[key];

        if (wasArrayValue && !Array.isArray(currentValue) && !!currentValue) {
          source[key] = [currentValue];
        } else if (Array.isArray(currentValue)) {
          source[key] = currentValue.filter(function (v) {
            return !!v;
          });
        } else if (_typeof(currentValue) === 'object') {
          _this2.normalizeStructures(currentValue, stack.concat(key));
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var saveForm = this.props.saveButton ? this.saveAndClose : null; // If data has id this is an update = don't show checkbox

      var saveAndAddCheckbox = false;

      if (this.props.saveAndAddCheckbox && !this.props.data.id) {
        saveForm = this.saveAndAdd;
        saveAndAddCheckbox = this.props.saveAndAddCheckbox;
      }

      var cancel = this.props.cancelButton ? this.onCancel : null;
      var saveAndAdd = this.props.saveAndAddButton ? this.saveAndAdd : null;
      var deleteButton = this.props.deleteButton ? this.deleteRecord : null;
      var deleteToggleButton = this.props.deleteButton ? this.toggleDeleteModal : null;

      var _Object$assign = Object.assign({
        deleteModalTitle: i18n.t('Are you sure?'),
        deleteModalConfirmButtonText: i18n.t('Yes'),
        deleteModalCancelButtonText: i18n.t('Cancel')
      }, this.props),
          deleteModalTitle = _Object$assign.deleteModalTitle,
          deleteModalConfirmButtonText = _Object$assign.deleteModalConfirmButtonText,
          deleteModalCancelButtonText = _Object$assign.deleteModalCancelButtonText;

      return /*#__PURE__*/React.createElement(Form$1, {
        ref: function ref(form) {
          return _this3.bootstrapForm = form;
        }
      }, /*#__PURE__*/React.createElement(ConfirmationModal, {
        confirmButtonText: deleteModalConfirmButtonText,
        cancelButtonText: deleteModalCancelButtonText,
        canClickOff: true,
        onConfirm: deleteButton,
        onCancel: this.toggleDeleteModal,
        show: this.state.deleteModal,
        title: deleteModalTitle,
        container: this.props.container
      }, /*#__PURE__*/React.createElement("div", null, this.props.deleteModalBody)), /*#__PURE__*/React.createElement(CancelConfirmModal, _extends({}, this.props.cancelConfirmText, {
        onCancelClose: this.onCancelClose,
        show: this.state.showCancelConfirm,
        container: this.props.container
      })), this.props.showAlertMessages && this.state.errorMessage && /*#__PURE__*/React.createElement(AlertMessage, {
        clearMessages: this.clearMessages,
        message: this.state.errorMessage,
        messageType: AlertMessageTypes.danger,
        visible: true
      }), /*#__PURE__*/React.createElement(FieldGroup, {
        activeLanguage: this.props.activeLanguage,
        className: this.props.fieldGroupClass,
        data: this.props.data,
        languages: this.props.languages,
        onValueChange: this.onValueChange,
        runValidation: this.state.runValidation,
        scrollContainerId: this.props.scrollContainerId
      }, this.props.children), this.props.hasFormButtons && /*#__PURE__*/React.createElement(FormSaveButtons, {
        buttonStyle: this.props.buttonStyle,
        buttonStyleDelete: this.props.buttonStyleDelete,
        buttonStyleSecondary: this.props.buttonStyleSecondary,
        cancel: cancel,
        cancelButtonText: this.props.cancelButtonText,
        cancelIconType: this.props.cancelIconType,
        className: this.props.buttonGroupClass,
        dataId: this.props.data && this.props.data.id ? this.props.data.id : '',
        dataType: this.props.data && this.props.data.type ? this.props.data.type : '',
        "delete": deleteToggleButton,
        deleteButtonText: this.props.deleteButtonText,
        deleteIconType: this.props.deleteIconType,
        isDisabled: this.state.isDisabled,
        leftButtonStyle: this.props.leftButtonStyle,
        leftButtonText: this.props.leftButtonText,
        leftButtonClick: this.props.leftButtonClick,
        leftButtonIconType: this.props.leftButtonIconType,
        noPaddingButtons: this.props.noPaddingButtons,
        saveAndAddCheckbox: saveAndAddCheckbox,
        saveAndAddCheckboxText: this.props.saveAndAddCheckboxText,
        save: saveForm,
        saveAndAdd: saveAndAdd,
        saveAndAddButtonText: this.props.saveAndAddButtonText,
        saveAndAddIconType: this.props.saveAndAddIconType,
        saveButtonAreaClassName: this.props.saveButtonAreaClassName,
        saveButtonDisabled: this.props.saveButtonDisabled,
        saveButtonText: this.props.saveButtonText,
        saveButtonDataAction: this.props.saveButtonDataAction,
        saveIconType: this.props.saveIconType
      }));
    }
  }]);
}(React.Component);

_defineProperty(Form, "propTypes", {
  activeLanguage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  addAction: PropTypes.func,
  buttonGroupClass: PropTypes.string,
  buttonStyle: PropTypes.string,
  buttonStyleDelete: PropTypes.string,
  buttonStyleSecondary: PropTypes.string,
  cancelButton: PropTypes.bool,
  cancelButtonText: PropTypes.string,
  cancelConfirmText: PropTypes.object,
  cancelIconType: PropTypes.string,
  clearMessages: PropTypes.func,
  children: PropTypes.any,
  container: PropTypes.node,
  data: PropTypes.object.isRequired,
  deepMerge: PropTypes.bool,
  deleteAction: PropTypes.func,
  deleteButton: PropTypes.bool,
  deleteButtonText: PropTypes.string,
  deleteDisableButtons: PropTypes.bool,
  deleteIconType: PropTypes.string,
  deleteModalTitle: PropTypes.string,
  deleteModalBody: PropTypes.string,
  deleteModalConfirmButtonText: PropTypes.string,
  deleteModalCancelButtonText: PropTypes.string,
  disableButtons: PropTypes.bool,
  errorMessage: PropTypes.string,
  fieldGroupClass: PropTypes.string,
  hasFormButtons: PropTypes.bool,
  languages: PropTypes.arrayOf(PropTypes.object),
  leftButtonStyle: PropTypes.string,
  leftButtonText: PropTypes.string,
  leftButtonClick: PropTypes.func,
  leftButtonIconType: PropTypes.string,
  noPaddingButtons: PropTypes.bool,
  onCancel: PropTypes.func,
  onCancelClose: PropTypes.func,
  onInvalidFormSubmit: PropTypes.func,
  saveAndAddButton: PropTypes.bool,
  saveAndAddButtonText: PropTypes.string,
  saveAndAddCheckbox: PropTypes.bool,
  saveAndAddCheckboxText: PropTypes.string,
  saveAndAddIconType: PropTypes.string,
  saveButton: PropTypes.bool,
  saveButtonAreaClassName: PropTypes.string,
  saveButtonDisabled: PropTypes.bool,
  saveButtonText: PropTypes.string,
  saveButtonDataAction: PropTypes.string,
  saveComplete: PropTypes.func,
  saveIconType: PropTypes.string,
  scrollContainerId: PropTypes.string,
  showAlertMessages: PropTypes.bool,
  skipCancelConfirmation: PropTypes.bool,
  successMessage: PropTypes.string,
  triggerCancel: PropTypes.bool,
  triggerSave: PropTypes.bool,
  triggerSaveAndAdd: PropTypes.bool,
  updateAction: PropTypes.func
});

_defineProperty(Form, "defaultProps", {
  cancelButton: true,
  deepMerge: false,
  deleteButton: false,
  deleteDisableButtons: true,
  deleteModalBody: '',
  hasFormButtons: true,
  showAlertMessages: true,
  saveAndAddButton: false,
  saveButton: true,
  saveButtonDisabled: false
});

Form.displayName = "Form";
export { Form };